import { Vue, Component } from 'vue-property-decorator';
import { wxSdkStore } from '@/store';

@Component
export default class shareMixin extends Vue {
  async wxShare(params = {}) {
    await wxSdkStore.share(params);
  }
}
